import { render } from "./Manufacturers.vue?vue&type=template&id=0baa1df9&scoped=true"
import script from "./Manufacturers.vue?vue&type=script&lang=ts"
export * from "./Manufacturers.vue?vue&type=script&lang=ts"

import "./Manufacturers.vue?vue&type=style&index=0&id=0baa1df9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0baa1df9"

export default script